<script lang="ts">
  import type { SessionModel } from '@24hbs/utils';
  import { isMarconiSession } from '$lib/utils/course-utils';
	import { CourseLearningUtils } from '$lib/utils/course-learning';
	import { useCourseTypeUtils } from '$lib/utils/courses/type-utils';
	import type { ICourseTypeFields } from '$lib/utils/contentful/types';
	import { onMount } from 'svelte';

  export let session: SessionModel;

  let courseType: ICourseTypeFields | null;

  let courseLearningData: {title: string, subtitle: string, details: {title: string, text: string}[]} = {
    title: 'Come partecipare',
    subtitle: '',
    details: [
      {
        title: '',
        text: ''
      }
    ]
  };

  let certificateReleaseEntity: string[] = [];
  if (isMarconiSession(session)) {
    certificateReleaseEntity = [
      "UniMarconi - prodotto BS24",
      "UniMarconi - prodotto UniMarconi",
      "Unitelma"
    ];
  }

  onMount(async () => {
    if (session && session.courseTypeFull) {
      const courseTypeUtils = useCourseTypeUtils(fetch);
      courseType = await courseTypeUtils.getCourseTypeByName(session.courseTypeFull);
    }
  });
  $: {
    if (courseType) {
      courseLearningData = CourseLearningUtils.getCourseLearningDetailsByCourseTypeSlug(courseType.slug, session.lessionMode.toLowerCase(), certificateReleaseEntity) || null;
    }
  }
</script>

{#if courseLearningData}
  <section class="learning-features">
    <div class="header">
      <p class="subtitle v-small mb-2">{courseLearningData.subtitle}</p>
      <h3>{courseLearningData.title}</h3>
    </div>
    {#each courseLearningData.details as detail}
      <div class="block">
        <h4>{detail.title}</h4>
        <p class="learning-features-list">
          {detail.text}
        </p>
      </div>
    {/each}
  </section>
{/if}

<style type="text/scss" lang="scss" scoped>
  h4 {
    @apply text-base font-bold;
  }

  .header {
    @apply mt-4;
    @apply mb-4 md:mb-6;
  }

  .block {
    padding-bottom: 2rem;
  }

  .block:not(:first-child) {
    padding-top: 2rem;
  }

  .block:not(:last-child) {
    border-bottom: 1px solid lightgray;
  }
</style>
